/* eslint-disable no-lone-blocks */
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {toast} from 'react-toastify'
import {ENV} from '../../../Utils/_helpers/EnvHelper'
const initialState = {
  forgotPassword: {},
  httpErr: false,
}
const API_URL = ENV().REACT_APP_API_URL

export const fetchAsyncForgotPassword: any = createAsyncThunk(
  'forgotPassword/fetchAsyncForgotPassword',
  async (data) => {
    const response = await axios.post(`${API_URL}auth/forgotPassword`, data, {})
    return response.data
  }
)
const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncForgotPassword.pending]: (state) => {},
    [fetchAsyncForgotPassword.fulfilled]: (state, {payload}) => {
      {
        payload.status === true ? toast.success(payload.message) : toast.error(payload.message)
      }
      return {...state, forgotPassword: payload}
    },
  },
})

export const getForgotPasswordData = (state: any) => state.forgotPassword?.forgotPassword

export default forgotPasswordSlice.reducer
